const inactivitytimerConfig = require('./inactivitytimer-config');

module.exports = inactivitytimerConfig;
